import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { puede, rutaInicio } from '../utils/permisos';

// `modulo`: clave de utils/permisos.js. Props legacy (adminOnly, supervisorOrAdmin, blockTecnico) siguen funcionando.
const ProtectedRoute = ({ children, modulo = null, adminOnly = false, clienteOnly = false, supervisorOrAdmin = false, blockTecnico = false }) => {
  const { user, cliente, userType, loading } = useAuth();
  const location = useLocation();
  // Al volver a ingresar se regresa a esta misma pantalla (no al dashboard)
  const volver = { from: { pathname: location.pathname, search: location.search, hash: location.hash } };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (clienteOnly) {
    if (!cliente || userType !== 'cliente') {
      return <Navigate to="/portal/login" replace state={volver} />;
    }
    return children;
  }

  if (!user || userType !== 'user') {
    return <Navigate to="/login" replace state={volver} />;
  }

  const inicio = rutaInicio(user);
  if (modulo && !puede(user, modulo)) {
    return <Navigate to={inicio} replace />;
  }

  if (adminOnly && user.rol !== 'admin') {
    return <Navigate to={inicio} replace />;
  }

  if (supervisorOrAdmin && !puede(user, 'aprobaciones')) {
    return <Navigate to={inicio} replace />;
  }

  if (blockTecnico && user.rol === 'tecnico') {
    return <Navigate to={inicio} replace />;
  }

  return children;
};

export default ProtectedRoute;